import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TitleService } from '@shared/services/title.service';

@Directive({
  selector: '[miqTitle]',
  standalone: false,
})
export class TitleDirective implements OnChanges {
  /**
   * Ideally has given title should match with any `value` of
   * `lookup/appcatalog` API
   */
  @Input() miqTitle: string;

  constructor(private titleService: TitleService) {}

  ngOnChanges({ miqTitle }: SimpleChanges) {
    if (miqTitle && this.miqTitle) {
      this.titleService.set(miqTitle.currentValue);
    } else {
      this.titleService.clear();
    }
  }
}
